var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-wrap"},[_c('Header',{attrs:{"title":'注册协议'}}),_c('div',{staticClass:"service"},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"txt",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }